export const socialsData = {
  github: "https://github.com/anuj72",
  linkedIn: "https://in.linkedin.com/in/anuj72",
  instagram: "https://www.instagram.com/anuj_sachan_",
  twitter: "https://twitter.com/@AnujSachan72",
  reddit: "https://www.reddit.com/user/",
  medium: "https://medium.com/@anuj_sachan",
  youtube: "https://www.youtube.com/channel/UClqsUUvOzIxkaN7DQsucffA",
};
